const locale = {
  appName: 'Kiness',
  tagline: 'Pinapanatiling konektado ang mga pamilya',
  signIn: 'Mag-sign in',
  signUp: 'Mag-sign up',
  signOut: 'Mag-sign out',
  email: 'Email',
  password: 'Password',
  name: 'Buong pangalan',
  facilityCode: 'Code ng pasilidad',
  facilityCodeHint: 'Hingin ang code na ito sa inyong care home',
  noAccount: 'Wala pang account?',
  haveAccount: 'May account na?',
  signingIn: 'Nagsa-sign in…',
  creatingAccount: 'Gumagawa ng account…',
  loginError: 'Hindi makapag-sign in — tingnan ang email at password',
  registerError: 'Hindi makagawa ng account — subukan muli',
  welcomeBack: 'Maligayang pagbabalik',
  welcomeNew: 'Sumali sa inyong care community',
  selectResident: 'Para kanino ang update na ito?',
  updatePlaceholder: 'Kumusta si {name} ngayon?',
  addPhoto: 'Magdagdag ng larawan',
  postUpdate: 'I-post ang update',
  posting: 'Nagpo-post…',
  postSuccess: 'Na-post na — aabisuhan ang pamilya',
  postError: 'Hindi ma-post — tingnan ang koneksyon at subukan muli',
  yourLovedOne: 'Inyong mahal sa buhay',
  familyFeed: 'Feed ng pamilya',
  tabFeed: 'Feed',
  tabRecord: 'Talaan',
  tabCalendar: 'Kalendaryo',
  tabPhotos: 'Larawan',
  noUpdates: 'Wala pang update — bumalik muli mamaya',
  pullRefresh: 'Hilahin pababa para i-refresh',
  refreshing: 'Nagre-refresh…',
  admin: 'Admin',
  dashboard: 'Dashboard',
  residents: 'Mga residente',
  familyLinks: 'Pag-link ng pamilya',
  staff: 'Staff',
  facility: 'Pasilidad',
  residentsCount: 'Mga residente',
  familyLinked: 'Naka-link na pamilya',
  updatesToday: 'Mga update ngayon',
  addResident: 'Magdagdag ng residente',
  editResident: 'I-edit',
  removeResident: 'Alisin',
  firstName: 'Pangalan',
  lastName: 'Apelyido',
  room: 'Kwarto',
  save: 'I-save',
  cancel: 'Kanselahin',
  addFamilyEmail: 'Magdagdag ng pamilya sa email',
  addStaffEmail: 'Magdagdag ng staff sa email',
  staffAdd: 'Idagdag',
  staffCount: '{count} sa staff',
  relationship: 'Relasyon',
  inviteSent: 'Handa na ang imbitasyon — maaari silang mag-register gamit ang code',
  loading: 'Naglo-load…',
  installTitle: 'Idagdag ang Kiness sa home screen',
  installBody: 'Mabilis na access sa mga update tungkol sa inyong mahal sa buhay',
  installButton: 'Idagdag sa Home Screen',
  installDismiss: 'Hindi muna',
  language: 'Wika',
  chooseLanguage: 'Piliin ang inyong wika',
  chooseLanguageSub: '选择您的语言',
  changeLanguageHint: 'Maaari ninyong palitan anumang oras gamit ang globe icon',
  english: 'English',
  chinese: '中文',
  newUpdate: 'Bagong update',
  from: 'mula kay',
  roomLabel: 'Kwarto',
  confirmRemove: 'Alisin ang residente na ito?',
  staffPostTitle: 'Mag-post ng update',
  adminTitle: 'Dashboard ng pasilidad',
  linkedFamily: 'Naka-link na pamilya',
  pendingInvite: 'Nakabinbing imbitasyon',
  noResidents: 'Wala pang residente — magdagdag ng una',
  noStaff: 'Wala pang staff',
  photoOptional: 'Larawan (opsyonal)',
  dashboardSettingUp: 'Inihahanda ang inyong dashboard…',
  dashboardEmptyHint: 'Magdagdag ng unang residente para magsimula',
};

export default locale;
